import { SummaryDashboardService } from '../services/SummaryDashboardService';

export function useSummaryDashboardService(): SummaryDashboardService {
  return new SummaryDashboardService(useApiClient(), useUserStore());
}
